<template>
    <tr>
        <td class="editor-content editor-label">Size</td>
        <td class="editor-content">
            <select class="form-control editor-form editor-select" v-model="selectedComponent.style.size">
                <option>xs</option>
                <option>sm</option>
                <option>lg</option>
                <option>2x</option>
                <option>3x</option>
                <option>5x</option>
                <option>7x</option>
                <option>10x</option>
            </select>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'IconSizeEditor',
        props: ['selectedComponent'],
        data () {
            return {
                model: webase.model
            }
        }
    }
</script>

<style>

</style>
